import React from "react";
import { Form, Label, Input, Textarea, StyledButton } from "./ContactStyle";
import "twin.macro";
import { useQueryParam, NumberParam } from "use-query-params";

const ContactForm = () => {
  const [success] = useQueryParam("success", NumberParam);

  return (
    <div>
      {success === 1 && (
        <p tw="bg-green-600 text-white font-bold text-center p-5 rounded-2xl">
          Successful!
        </p>
      )}
      <Form action="https://mailthis.to/contact@techtomatoes.in" method="POST">
        <div>
          <Label>Name</Label>
          <Input type="text" name="name" placeholder="John Doe" />
        </div>
        <div>
          <Label>Company</Label>
          <Input type="text" name="company" placeholder="Microsoft" />
        </div>
        <div>
          <Label>Email Address</Label>
          <Input type="email" name="_replyto" placeholder="example@gmail.com" />
        </div>
        <div>
          <Label>Phone Number</Label>
          <Input type="text" name="phone" placeholder="1234567890" />
        </div>
        <div tw="md:col-span-2">
          <Label>Message</Label>
          <Textarea name="message" rows="5" placeholder="Type your message" />
        </div>
        <input
          type="hidden"
          name="_subject"
          value="Contact form submitted from techtomatoes.in"
        />
        <input
          type="hidden"
          name="_after"
          value="http://techtomatoes.in/contacts?success=1"
        />
        {/* <input
          type="hidden"
          name="_after"
          value="https://techtomatoes.in/contacts?success=1"
        /> */}
        <div tw="md:col-span-2">
          <StyledButton type="submit">Submit</StyledButton>
        </div>
      </Form>
    </div>
  );
};

export default ContactForm;
